import splt from "spltjs";
import anime from "animejs";
import dayjs from "dayjs";
// 设计图宽
const BASE_VW = "1920";
// 设计图高
const BASE_VH = "1080";

const vw = function(px) {
    return (px / BASE_VW) * 100 + "vw";
};
const vh = function(px) {
    return (px / BASE_VH) * 100 + "vh";
};
const formatter = function(arr) {
    const numbers = arr
        .toString()
        .split("")
        .reverse();
    let segs = [];
    while (numbers.length) segs.push(numbers.splice(0, 3).join(""));
    return segs
        .join(",")
        .split("")
        .reverse()
        .join("");
};
const numberToFix = function(num, style, textAlign = "center") {
    const options = {
        number: [num],
        content: "{nt}",
        textAlign,
        style: style,
        formatter: formatter
    };
    return options;
};
function throttle(fn, wait) {
    let pre = Date.now();
    return function() {
        let context = this;
        let args = arguments;
        let now = Date.now();
        if (now - pre >= wait) {
            fn.apply(context, args);
            pre = Date.now();
        }
    };
}
function debounce(fn, delay) {
    // 防抖
    let timer;
    return function(...args) {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            fn.apply(this, args);
        }, delay);
    };
}
// 对象深度克隆
function deepClone(data) {
    let d;
    if (typeof data === "object") {
        if (data == null) {
            d = null;
        } else {
            if (data.constructor === Array) {
                d = [];
                for (let i in data) {
                    d.push(deepClone(data[i]));
                }
            } else {
                d = {};
                for (let i in data) {
                    d[i] = deepClone(data[i]);
                }
            }
        }
    } else {
        d = data;
    }
    return d;
}

// 查找数组对象最大值
function findMax(arr, name) {
    let max = arr[0][name];
    arr.forEach(res => {
        if (res[name] > max) {
            max = res[name];
        }
    });
    return max;
}
// 排序
function sort(arr, name) {
    if (!arr || arr.length === 0) {
        return [];
    }
    let leader = arr[0];
    let left = [];
    let right = [];
    for (let i = 1; i < arr.length; i++) {
        if (arr[i][name] > leader[name]) {
            left.push(arr[i]);
        } else {
            right.push(arr[i]);
        }
    }
    left = sort(left, name);
    right = sort(right, name);
    left.push(leader);
    return left.concat(right);
}

/**
 * 日期格式化
 */
function dateFormat(date, format) {
    format = format || "yyyy-MM-dd hh:mm:ss";
    if (date !== "Invalid Date") {
        let o = {
            "M+": date.getMonth() + 1, // month
            "d+": date.getDate(), // day
            "h+": date.getHours(), // hour
            "m+": date.getMinutes(), // minute
            "s+": date.getSeconds(), // second
            "q+": Math.floor((date.getMonth() + 3) / 3), // quarter
            S: date.getMilliseconds() // millisecond
        };
        if (/(y+)/.test(format)) {
            format = format.replace(
                RegExp.$1,
                (date.getFullYear() + "").substr(4 - RegExp.$1.length)
            );
        }
        for (let k in o) {
            if (new RegExp("(" + k + ")").test(format)) {
                format = format.replace(
                    RegExp.$1,
                    RegExp.$1.length === 1
                        ? o[k]
                        : ("00" + o[k]).substr(("" + o[k]).length)
                );
            }
        }
        return format;
    }
    return "";
}
function getWeek() {
    let day = new Date().getDay();
    let weekArr = ["天", "一", "二", "三", "四", "五", "六"];
    return `星期${weekArr[day]}`;
}

//信息脱敏
export function infoHide(str) {
    if (str !== null && str !== undefined) {
        if (str.length > 6) {
            return (
                str.substring(0, 3) +
                "********" +
                str.substr(str.length - 3, str.length)
            );
        }
    } else {
        return "";
    }
}

// 判断是否为空
export function isEmpty(val) {
    if (typeof val === "boolean") {
        return false;
    }
    if (typeof val === "number") {
        return false;
    }
    if (val instanceof Array) {
        if (val.length === 0) return true;
    } else if (val instanceof Object) {
        if (JSON.stringify(val) === "{}") return true;
    } else {
        if (
            val === "null" ||
            val == null ||
            val === "undefined" ||
            val === undefined ||
            val === ""
        )
            return true;
        return false;
    }
    return false;
}

function echartSort(targetList, sourceList, sourceValue) {
    // 目标顺序 原来顺序 原值
    let arr = [];
    targetList.forEach((item, index) => {
        sourceList.forEach((subItem, subIndex) => {
            if (item === subItem) {
                arr.push(sourceValue[subIndex]);
            }
        });
    });
    return arr;
}
function fontSize(val = 16) {
    return (val / 1920) * innerWidth;
}
function textAnime() {
    anime({
        begin: splt({ reveal: true }),
        targets: ".char",
        opacity: [0, 1],
        scale: [0.5, 1],
        delay: anime.stagger(50),
        easing: "cubicBezier(.71,-0.77,.43,1.67)",
        complete: () => {
            splt.revert();
        }
    });
}
/**
 *  关键字高亮
 *  @param {string} str - 原始字符串
 *  @param {string} keyField - 关键字段
 *  @param {string} color - 颜色
 *  @author hare
 */
function highlightStr(str, keyField, color) {
    // 截取关键字段
    let agoStr = str.split(keyField);
    let nodes = [];
    // if (agoStr.length > 1) {
    let formatSearch = (e, key) => {
        return e.replace(new RegExp(key, "ig"), $1 => {
            return `<span style="color: ${color}; font-weight: 500;" class="light">${$1}</span>`;
        });
    };
    let strHtml = formatSearch(str, keyField);
    //使用插件进行html代码转换(htmlStr为html代码，htmlNodes是转换后的数组)
    //   parse(strHtml, (err, nodesList) => {
    //     if (!err) {
    //       nodes = nodes.concat(nodesList);
    //     } else {
    //         console.log('富文本字符串转数组出错')
    //     }
    //   })
    //   // 输出使用 v-html
    //   // 例如：<view v-html="item.subTitle"/>
    // } else {
    //   parse(agoStr[0], (err, nodesList) => {
    //     if (!err) {
    //       nodes = nodes.concat(nodesList);
    //     } else {
    //         console.log('富文本字符串转数组出错')
    //     }
    //   })
    // }
    return strHtml;
}
//获取最近15天
function getNowDate15() {
    let list = [];
    for (let i = -14; i <= 0; i++) {
        const timeOne = new Date();
        timeOne.setDate(timeOne.getDate() + i); //获取p_count天后的日期
        let month = timeOne.getMonth() + 1; //获取当前月份的日期
        let day = timeOne.getDate();
        month = month < 10 ? "0" + month : month;
        day = day < 10 ? "0" + day : day;
        let date = month + "." + day;
        list.push(date);
        console.log("获取时间", month + "." + day);
    }
    return list;
}
//获取最近天
function getNowDateDay(data) {
    let list = [];
    for (let i = (data-1)*-1; i <= 0; i++) {
        const timeOne = new Date();
        timeOne.setDate(timeOne.getDate() + i); //获取p_count天后的日期
        let month = timeOne.getMonth() + 1; //获取当前月份的日期
        let day = timeOne.getDate();
        month = month < 10 ? "0" + month : month;
        day = day < 10 ? "0" + day : day;
        let date = month + "." + day;
        list.push(date);
        console.log("获取时间", month + "." + day);
    }
    return list;
}
//获取13个月
function getMonth(num) {
    let dataArr = [];
    let data = new Date();
    let year = data.getFullYear();
    data.setMonth(data.getMonth() + 1, 1); //获取到当前月份,设置月份
    for (var i = 0; i < num; i++) {
        data.setMonth(data.getMonth() - 1); //每次循环一次 月份值减1
        let m = data.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        dataArr.push(data.getFullYear() + "-" + m);
    }
    console.log("获取num个月", dataArr);
    return dataArr.reverse();
}

//根据传入时间获取时间差
function getNowDate(params) {
    const timeOne = new Date();
    const year = timeOne.getFullYear();
    let month = timeOne.getMonth() + 1;
    let day = timeOne.getDate();
    month = month < 10 ? "0" + month : month;
    day = day < 10 ? "0" + day : day;
    const time = `${year}-${month}-${day}`;
    console.log("时间", time);
    //计算时间差
    let num = dayjs(time).diff(params, "day");
    console.log("天数", num);
    return num;
}

//获取当前月份的所有日期
function nowMonth(){
    let days = new Date().getDate()
    let month = new Date().getMonth() + 1
    let year = new Date().getFullYear()
    let day = new Date(year, month, 0).getDate();
    let now = new Date(days);
    let currentMonthNum = day;
    let currentMonth = [];
    for (let i = 1; i <= currentMonthNum; i++) {
        currentMonth.push(month + "-" + i);
    }
    return currentMonth
}

//定时退出登录
function timeLogout(keyOne,keyTwo,times){
    let num = 1
    let time = new Date().getTime()
    if(localStorage.getItem(keyOne) === null){
        localStorage.setItem(keyOne,time.toString())
    }
    let timeOne = Number(localStorage.getItem(keyOne))
    console.log("跳转时间",localStorage.getItem(keyOne),)
    console.log("跳转时间",time-timeOne)
    if(time-timeOne > times){
        console.log("清除缓存")
        localStorage.removeItem(keyTwo)
        localStorage.removeItem(keyOne)
        num = 0
    }
    return num
}

export default {
    // 输出
    vw,
    vh,
    formatter,
    numberToFix,
    deepClone,
    findMax,
    sort,
    dateFormat,
    getWeek,
    debounce,
    throttle,
    isEmpty,
    echartSort,
    fontSize,
    textAnime,
    highlightStr,
    infoHide,
    getNowDate15,
    getNowDateDay,
    getNowDate,
    getMonth,
    nowMonth,
    timeLogout
};



// WEBPACK FOOTER //
// ./src/utils/util.js